document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Media Gallery Filter Drawer Loaded");

  const openFilter = document.getElementById("open-filter");
  const closeFilter = document.getElementById("close-filter");
  const filterDrawer = document.getElementById("filter-drawer");
  const checkboxes = document.querySelectorAll(
    "#gallery-filter input[type='checkbox'], #gallery-sub-filter input[type='checkbox']"
  );
  const galleryItems = document.querySelectorAll(".gallery-item");
  const clearButton = document.getElementById("clear-filters");

  function filterGallery() {
    const selectedMainCats = Array.from(
      document.querySelectorAll("#gallery-filter input[type='checkbox']")
    )
      .filter((cb) => cb.checked && cb.value !== "all")
      .map((cb) => cb.value.trim());

    const selectedSubCats = Array.from(
      document.querySelectorAll("#gallery-sub-filter input[type='checkbox']")
    )
      .filter((cb) => cb.checked && cb.value !== "all")
      .map((cb) => cb.value.trim());

    const showAllMain = selectedMainCats.length === 0;
    const showAllSub = selectedSubCats.length === 0;

    document.querySelectorAll(".gallery-item").forEach((item) => {
      const itemCategory = item.getAttribute("data-category")?.trim() || "";
      const itemSubcats = (item.getAttribute("data-sub-category") || "")
        .split(",")
        .map((s) => s.trim().toLowerCase());

      const matchesMain =
        showAllMain || selectedMainCats.includes(itemCategory.toLowerCase());

      const matchesSub =
        showAllSub ||
        itemSubcats.some((sub) => selectedSubCats.includes(sub.toLowerCase()));

      const filterByMain = selectedMainCats.length > 0;
      const filterBySub = selectedSubCats.length > 0;

      let shouldShow = false;

      // Match logic
      if (filterByMain && filterBySub) {
        // Both selected: must match both
        shouldShow = matchesMain && matchesSub;
      } else if (filterByMain) {
        shouldShow = matchesMain;
      } else if (filterBySub) {
        shouldShow = matchesSub;
      } else {
        // Nothing selected, show all
        shouldShow = true;
      }

      item.style.display = shouldShow ? "" : "none";
    });
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      if (this.value === "all") {
        checkboxes.forEach((cb) => {
          if (cb.value !== "all") cb.checked = false;
        });
        filterGallery();
      } else {
        document.querySelector(
          "#gallery-filter input[value='all']"
        ).checked = false;
        filterGallery();
      }
    });
  });

  // ✅ Clear Filters Button
  clearButton.addEventListener("click", function () {
    checkboxes.forEach((cb) => (cb.checked = false));
    document.querySelector("#gallery-filter input[value='all']").checked = true;
    filterGallery();
  });

  // ✅ Open Filter Drawer
  openFilter.addEventListener("click", function () {
    filterDrawer.classList.add("open");
  });

  // ✅ Close Filter Drawer
  closeFilter.addEventListener("click", function () {
    filterDrawer.classList.remove("open");
  });

  // ✅ Close Drawer When Clicking Outside
  document.addEventListener("click", function (event) {
    if (
      !filterDrawer.contains(event.target) &&
      !openFilter.contains(event.target)
    ) {
      filterDrawer.classList.remove("open");
    }
  });

  // ✅ Prevent Closing When Clicking Inside Drawer
  filterDrawer.addEventListener("click", function (event) {
    event.stopPropagation();
  });
});
